import { servicosSaudeEspecialidadeApi } from "@/api/ServicosSaudeEspecialidadeApi";
import EspecialidadeFiltro from "@/models/cadastros/saude/EspecialidadeFiltro";
import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";

class SaudeEspecialidadeService {
  pesquisar(filtro?: EspecialidadeFiltro) {
    const filtroDTO = {
      nome: filtro?.nome,
      tipoAtendimento: filtro?.tipoAtendimento?.name,
      ramo: filtro?.ramo?.name,
      page: filtro?.options?.page ? filtro?.options?.page - 1 : 0,
      size: filtro?.options?.itemsPerPage,
      sort: "nome",
    };
    return servicosSaudeEspecialidadeApi.obterEspecialidades(filtroDTO);
  }

  salvar(especialidade: EspecialidadeModel) {
    const especialidadeDTO = {
      nome: especialidade.nome,
      tipoAtendimento: especialidade.tipoAtendimento?.name,
      ramo: especialidade.ramo?.name,
      orientacaoPreparo: especialidade.orientacaoPreparo,
    };

    return servicosSaudeEspecialidadeApi.salvarEspecialidade(especialidadeDTO);
  }

  atualizar(especialidade: EspecialidadeModel, idEspecialidade: Number) {
    const especialidadeDTO = {
      nome: especialidade.nome,
      tipoAtendimento: especialidade?.tipoAtendimento?.name,
      ramo: especialidade?.ramo?.name,
      orientacaoPreparo: especialidade.orientacaoPreparo,
    };

    return servicosSaudeEspecialidadeApi.atualizarEspecialidade(idEspecialidade, especialidadeDTO);
  }

  obterPorId(idEspecialidade: Number) {
    return servicosSaudeEspecialidadeApi.obterEspecialidadePorId(idEspecialidade);
  }

  deletar(idEspecialidade: Number) {
    return servicosSaudeEspecialidadeApi.deletarEspecialidade(idEspecialidade);
  }
}

export const saudeEspecialidadeService = new SaudeEspecialidadeService();
